"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _safeConfig = require("../../../packages/config/safe-config");
var _reCaptcha = _interopRequireDefault(require("../../../services/re-captcha"));
var _index = require("../index.types");
const useReCaptchaInterceptor = function () {
  const {
    REACT_APP_RECAPTCHA_CONSUMER,
    REACT_APP_REFERRER_URL
  } = (0, _safeConfig.useSafeConfigSlice)(["REACT_APP_RECAPTCHA_CONSUMER", "REACT_APP_REFERRER_URL"]);
  const service = (0, _reCaptcha.default)();
  return async function (config) {
    try {
      if (!(0, _index.isEOSRequestConfig)(config)) return config;
      if (!config.includeReCaptcha) return config;
      const reCaptchaToken = await service.findReCaptchaToken();
      if (config.method === "get") {
        config.headers["x-auth-token"] = reCaptchaToken;
        config.headers["x-consumer"] = REACT_APP_RECAPTCHA_CONSUMER;
        config.headers["x-referrer"] = REACT_APP_REFERRER_URL;
      } else {
        const data = config.data;
        data.tokenAttributes = {
          xauthToken: reCaptchaToken,
          xconsumer: REACT_APP_RECAPTCHA_CONSUMER,
          xreferrer: REACT_APP_REFERRER_URL
        };
      }
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  };
};
var _default = exports.default = useReCaptchaInterceptor;